import { ValueType } from "src/types/productCategory";
import { numberToCurrency } from "./currency";

/* eslint-disable import/prefer-default-export */
export const getCoverageValueByType = (
  type: string,
  value: any,
  locale: string = "en"
): string => {
  if (type === ValueType.number) {
    return numberToCurrency(+value);
  }
  if (type === ValueType.string) {
    return value[locale];
  }
  return "";
};
